import * as React from "react";
import { createComponent } from "@lit/react";
import Component from "../../components/Masthead/sgds-masthead";
import { register } from "../../utils/ce-registry";

register("sgds-masthead", Component);

export default createComponent({
  react: React,
  tagName: "sgds-masthead",
  elementClass: Component,
  events: {}
});
